import { Fields as Merchant } from 'models/Merchant'
import { api } from './index'

export type UpdateMerchantPayload = Partial<Merchant>

export const merchantsApi = api.injectEndpoints({
  endpoints: builder => ({
    updateMerchant: builder.mutation<
      { merchant: Merchant },
      { data: UpdateMerchantPayload }
    >({
      query: ({ data }) => ({
        url: '', // The dynamic url already includes /merchant/:id, see src/api/utils.ts buildBaseUrl function
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: result => [
        { type: 'Merchant', id: result?.merchant.id },
      ],
    }),
  }),
})

export const { useUpdateMerchantMutation } = merchantsApi
